<script setup>
import { ref, computed, onMounted } from 'vue'
import { useRouter } from 'vue-router'
import { usePerfilUsuarioStore } from '@/stores/perfilUsuario'
import { useNotificationStore } from '@/stores/notification'

const router = useRouter()
const perfilUsuarioStore = usePerfilUsuarioStore()
const notificationStore = useNotificationStore()
const search = ref('')
const dialog = ref(false)
const perfilIdToDelete = ref(null)

onMounted(() => {
  perfilUsuarioStore.fetchPerfis()
})

const edit = (id) => {
  router.push({ name: 'PerfilUsuarioForm', params: { id } })
}

const create = () => {
  router.push({ name: 'PerfilUsuarioForm' })
}

const confirmDelete = (id) => {
  perfilIdToDelete.value = id
  dialog.value = true
}

const deletePerfil = async () => {
  if (perfilIdToDelete.value) {
    await perfilUsuarioStore.deletePerfil(perfilIdToDelete.value)
    dialog.value = false
    notificationStore.showNotification('Perfil deletado com sucesso!', 'success')
  }
}

const perfis = computed(() => perfilUsuarioStore.perfis || [])
const loading = computed(() => perfilUsuarioStore.loading)
const error = computed(() => perfilUsuarioStore.error)

</script>

<template>
  <div>
    <v-row>
      <v-col cols="12" class="d-flex align-center">
        <h1 class="text-h4">Gerenciar Perfis de Usuário</h1>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="create">
          <v-icon start>mdi-plus</v-icon>
          Novo Perfil
        </v-btn>
      </v-col>
    </v-row>

    <v-alert v-if="error" type="error" closable class="mb-4">
      {{ error }}
    </v-alert>

    <v-progress-linear v-if="loading" indeterminate color="primary"></v-progress-linear>

    <v-data-table 
      :headers="[
        { title: 'ID', value: 'id' },
        { title: 'Descrição', value: 'descricao' },
        { title: 'Nível', value: 'nivel' },
        { title: 'Ações', value: 'actions', sortable: false }
      ]"
      :items="perfis"
      :search="search"
      class="custom-table"
    >
      <template #top>
        <v-text-field
          v-model="search"
          label="Pesquisar"
          prepend-inner-icon="mdi-magnify"
          variant="outlined"
          single-line
        ></v-text-field>
      </template>

      <template #item="{ item }">
        <tr>
          <td>{{ item.id }}</td>
          <td>{{ item.descricao }}</td>
          <td>{{ item.nivel }}</td>
          <td>
            <v-icon class="mr-3" color="medium-emphasis" icon="mdi-pencil" size="large" @click="edit(item.id)"></v-icon>
            <v-icon class="ml-2" color="medium-emphasis" icon="mdi-delete" size="large" @click="confirmDelete(item.id)"></v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>

    <v-dialog v-model="dialog" max-width="500">
      <v-card>
        <v-card-title class="text-h5">Confirmar Exclusão</v-card-title>
        <v-card-text>Tem certeza de que deseja excluir este perfil?</v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="primary" text @click="dialog = false">Cancelar</v-btn>
          <v-btn color="primary" @click="deletePerfil">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<style scoped>

</style>
